import { Flex, Icon } from "@chakra-ui/react";
import { iconColorPaletteFor, iconComponentFor } from "features/Path/icons";

interface IconTileProps {
  icon: string | null;
  color: string | null;
  size?: number;
}

export default function IconTile({ icon, color, size = 30 }: IconTileProps) {
  const palette = iconColorPaletteFor(color);
  const IconComponent = iconComponentFor(icon);

  return (
    <Flex
      align="center"
      justify="center"
      w={`${size}px`}
      h={`${size}px`}
      borderRadius="md"
      bg={palette.bg}
      flexShrink={0}
      aria-hidden
    >
      <Icon as={IconComponent} boxSize={`${Math.round(size * 0.55)}px`} color={palette.fg} />
    </Flex>
  );
}
